
<template>
    <bc-tooltip :class="{'hidden-sm-and-down': !permanent}">
        <template slot="activator">
            <v-btn icon @mouseup.left="$emit('invoke-method')">
                <v-icon>refresh</v-icon>
            </v-btn>
        </template>
        {{ $t('lang.refresh') }}
    </bc-tooltip>
</template>


<script>
export default {
    props: {
        permanent: {
            type: Boolean,
            default: false
        },
    },
}
</script>